module.exports = __webpack_public_path__ + "img/item_default.f5ea0e87.png";